module.exports = __webpack_public_path__ + "static/media/PM93.e802b0ac.png";